import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.productForm = null;
  }

  connectedCallback() {
    const scope = this.closest('product-card, [data-ref="product-section-content"], [data-ref="popup-content"]');
    this.productForm = scope?.querySelector('[data-ref="product-form"]');

    this.productForm?.addEventListener(ThemeEvents.formUpdated, this.updatePrice);
    this.productForm?.addEventListener(ThemeEvents.variantUpdated, this.updateUnitPrice);
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener(ThemeEvents.formUpdated, this.updatePrice);
    this.productForm?.removeEventListener(ThemeEvents.variantUpdated, this.updateUnitPrice);
  }

  updatePrice = (event) => {
    if (this.classList.contains('v8-unit-price')) return;
    const priceContainer = this.querySelector('[data-ref="price-container"]');
    if (!priceContainer) return;

    // Récupérer les prix depuis l'événement
    let { price, compare_at_price, difference_price } = event.detail.prices;
    // VEYRE keeps the product's unit price separate from the Duo total on the CTA.
    if (this.classList.contains('veyre-unit-price') && Number.isFinite(event.detail.prices.display_unit_price)) {
      price = event.detail.prices.display_unit_price;
      compare_at_price = event.detail.prices.display_unit_compare_at_price;
      difference_price = compare_at_price - price;
    }

    // Mettre à jour le prix
    const priceElement = priceContainer.querySelector('[data-ref="price"]');
    if (priceElement) {
      priceElement.innerHTML = formatMoney(price);
    }

    // Mettre à jour le prix barré
    const compareAtPriceElement = priceContainer.querySelector('[data-ref="compare-at-price"]');
    if (compareAtPriceElement) {
      compareAtPriceElement.innerHTML = compare_at_price > price ? formatMoney(compare_at_price) : '';
    }

    // Mettre à jour le badge de réduction
    const differencePriceElement = priceContainer.querySelector('[data-ref="difference-price-value"]');
    if (differencePriceElement) {
      const salesBadgeType = this.dataset.salesBadge;
      const showMinus = differencePriceElement.dataset.showMinus !== 'true';

      // Afficher le badge seulement s'il y a une réduction (compare_at_price > price)
      if (compare_at_price > price) {
        const prefix = showMinus ? '-' : '';
        if (salesBadgeType === 'percentage') {
          const percentage = Math.round(((compare_at_price - price) * 100) / compare_at_price);
          differencePriceElement.innerHTML = `${prefix}${percentage}%`;
        } else {
          differencePriceElement.innerHTML = `${prefix}${formatMoney(difference_price)}`;
        }
      } else {
        // Pas de réduction, vider le badge
        differencePriceElement.innerHTML = '';
      }
    }
  };

  updateUnitPrice = (event) => {
    if (this.classList.contains('v8-unit-price') && event.detail.resource) {
      const variant = event.detail.resource;
      const amount = this.querySelector('[data-ref="price"]');
      const compare = this.querySelector('[data-ref="compare-at-price"]');
      if (amount) amount.textContent = formatMoney(variant.price);
      if (compare) compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
    }
    const unitPriceElement = this.querySelector('[data-ref="unit-price"]');
    if (!unitPriceElement) return;

    const variant = event.detail.resource;
    if (!variant?.unit_price_measurement) {
      unitPriceElement.innerHTML = '';
      return;
    }

    const formattedPrice = formatMoney(variant.unit_price);
    const { reference_value, reference_unit } = variant.unit_price_measurement;
    const reference = reference_value !== 1 ? `${reference_value} ${reference_unit}` : reference_unit;
    unitPriceElement.innerHTML = `${formattedPrice} / ${reference}`;
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}

